import { render, staticRenderFns } from "./EventArea.vue?vue&type=template&id=bf5d6492"
import script from "./EventArea.vue?vue&type=script&lang=js"
export * from "./EventArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports